import Vue from 'vue'
import Vuetify from 'vuetify/lib'

Vue.use(Vuetify)

export default new Vuetify({
    theme: {
      themes: {
        light: {
          primary: '#006098',
          secondary: '#b0bec5',
          white: '#fff',
          grey: '#4E5152',
          lightBlue: '#2196f3',
          accent: '#8c9eff',
          error: '#b71c1c',
        },
      },
    },
  })